import { tap, debounceTime, switchMap, timeout } from 'rxjs/operators';
import { ContactType, SalesStatus, SecurityRight } from 'app/utility/enums';
import { ContactSearchResultModel } from 'app/models/dms/contactSearchResult.model';
import { ContactOrderBy, ContactClass } from 'app/utility/enums';
import { Component, OnInit, OnDestroy, Inject, Input, Output, EventEmitter, HostListener, ChangeDetectorRef } from '@angular/core';

import { Observable, Subscription } from 'rxjs';

import { ContactSearchParamsModel } from 'app/models/dms/contactSearchParams.model';
import { ContactResultModel } from 'app/models/dms/contact.model';
import { UserModel } from 'app/models/authentication/user.model';
import { ListItemModel } from 'app/models/shared/listItem.model';

import { ContactService } from 'app/services/contact.service';
import { UserService } from 'app/services/user.service';

import { LookupInternalModel } from 'app/models/shared/lookup.model';

import { LoadingController, Platform } from '@ionic/angular';

import { StorageService } from 'app/services/storage.service';
import { Constants } from 'app/utility/constants';
import { StringHelper } from 'app/utility/stringhelper';
import { MessageService } from 'app/services/message.service';


@Component({
    selector: 'app-contact-list',
    templateUrl: './contact-list.component.html',
    styleUrls: ['./contact-list.component.scss'],
    standalone: false
})
export class ContactListComponent implements OnInit, OnDestroy
{

    @Input() inParams: ContactSearchParamsModel;
    @Input() allowActions: boolean = false;
    @Input() addNew: boolean = false;
    @Output() contactSelected = new EventEmitter<ContactResultModel>();
    @Output() newContactSelected = new EventEmitter<string>();
    @Input() modal: boolean = false;
    @Input() detailIcon: 'chevron-forward' | '' = '';

    showSpinner: boolean = false;
    searchLoading: boolean = false;
    isLoadingNewSearch: boolean = false;
    searchReloading: boolean = false;

    //resetContacts: if true when performing a search, current contacts will be overwritten instead of appended to
    private resetContacts: boolean = true;
    contacts: ContactResultModel[];

    rowCnt: number;
    rowCntFormatted: string = "0";

    dealerships: ContactResultModel[] = null;
    listDealerships: ListItemModel[];

    statuses: LookupInternalModel[] = null;
    listStatuses: ListItemModel[];

    selectableStatuses: LookupInternalModel[] = null;
    listSelectableStatuses: ListItemModel[];

    suppliers: ContactResultModel[] = null;
    listSuppliers: ListItemModel[];

    currentUser: UserModel;

    currentFilters: ListItemModel[];

    sortColumns: ListItemModel[];

    currentSortColumn: string;
    isMobile: boolean = false;

    constructor(
        private contactService: ContactService,
        private userService: UserService,
        private loadingController: LoadingController,
        private storage: StorageService,
        private platform: Platform,
        private cd: ChangeDetectorRef,
        private messageService: MessageService
    )
    {
        // console.log('Contact list component created');
    }

    ngOnInit()
    {
        const contactMessageSubscription = this.messageService.contactMessage.subscribe({
            next: (message) =>
            {
                console.log("Contact message received:", message);
                if (!message || !message.contactId)
                {
                    console.error("Invalid message received:", message);
                    return;
                }
                for (let i = 0; i < this.contacts.length; i++)
                {
                    if (this.contacts[i].contactId == message.contactId)
                    {
                        // Map updated ContactModel data to ContactResultModel
                        Object.assign(this.contacts[i], message);
                        this.contacts[i].hide = true;
                        console.log("Contact updated: " + message.displayName);
                        this.cd.markForCheck();
                        setTimeout(() =>
                        {
                            this.contacts[i].hide = false;
                            this.cd.markForCheck();
                        }, 1000);
                    }
                }
            },
            error: (error) =>
            {
                console.error("Error in contact message subscription:", error);
            }
        });
        this.subscriptions.push(contactMessageSubscription);

        this.platform.ready().then(() =>
        {
            this.isMobile = (this.platform.width() < 800);
            this.platform.resize.subscribe(() =>
            {
                this.isMobile = (this.platform.width() < 800);
            });
        });


        if (this.inParams == null)
        {
            this.inParams = new ContactSearchParamsModel();
        }

        if (!this.inParams.enforce)
        {
            this.storage.get(Constants.IonicStorage_ContactListSort).then((val) =>
            {
                if (val)
                {
                    this.currentSortColumn = val;
                    this.inParams.orderByIn = val;
                    this.inParams.orderByDesc = false;
                    if (val.includes("Desc"))
                    {
                        this.inParams.orderByIn = val.replace("Desc", "");
                        this.inParams.orderByDesc = true;
                    }
                }
            });
        }

        if (this.inParams.orderByIn == null)
        {
            this.inParams.orderByIn = ContactOrderBy.FirstName;
        }

        if (this.inParams.contactClass == ContactClass.Individual)
        {
            this.sortColumns = [
                new ListItemModel(ContactOrderBy.FirstName + '', 'First name', 'A to Z', 'asc'),
                new ListItemModel(ContactOrderBy.FirstNameDesc + '', 'First name', 'Z to A', 'desc'),
                new ListItemModel(ContactOrderBy.LastName + '', 'Last name', 'A to Z', 'asc'),
                new ListItemModel(ContactOrderBy.LastNameDesc + '', 'Last name', 'Z to A', 'desc'),
                new ListItemModel(ContactOrderBy.CreatedDateDesc + '', 'Date created', 'New to Old', 'desc'),
                new ListItemModel(ContactOrderBy.CreatedDate + '', 'Date created', 'Old to New', 'asc'),
                new ListItemModel(ContactOrderBy.ModifiedDateDesc + '', 'Date modified', 'New to Old', 'desc'),
                new ListItemModel(ContactOrderBy.ModifiedDate + '', 'Date modified', 'Old to New', 'asc'),


            ];
            var company_order_by: ContactOrderBy[] = [ContactOrderBy.Company, ContactOrderBy.CompanyDesc];
            if (company_order_by.includes(this.inParams.orderByIn))
            {
                this.inParams.orderByIn = ContactOrderBy.FirstName;
            }
        }
        else if (this.inParams.contactClass == ContactClass.Business)
        {
            this.sortColumns = [
                new ListItemModel(ContactOrderBy.Company + '', 'Company', 'A to Z', 'asc'),
                new ListItemModel(ContactOrderBy.CompanyDesc + '', 'Company', 'Z to A', 'desc'),
                new ListItemModel(ContactOrderBy.CreatedDateDesc + '', 'Date created', 'New to Old', 'desc'),
                new ListItemModel(ContactOrderBy.CreatedDate + '', 'Date created', 'Old to New', 'asc'),
                new ListItemModel(ContactOrderBy.ModifiedDateDesc + '', 'Date modified', 'New to Old', 'desc'),
                new ListItemModel(ContactOrderBy.ModifiedDate + '', 'Date modified', 'Old to New', 'asc'),
            ];
            var individual_order_by = [ContactOrderBy.FirstName, ContactOrderBy.FirstNameDesc, ContactOrderBy.LastName, ContactOrderBy.LastNameDesc];
            if (individual_order_by.includes(this.inParams.orderByIn))
            {
                this.inParams.orderByIn = ContactOrderBy.Company;
            }
        }
        else
        {
            this.sortColumns = [
                new ListItemModel(ContactOrderBy.FirstName + '', 'First name', 'A to Z', 'asc'),
                new ListItemModel(ContactOrderBy.FirstNameDesc + '', 'First name', 'Z to A', 'desc'),
                new ListItemModel(ContactOrderBy.LastName + '', 'Last name', 'A to Z', 'asc'),
                new ListItemModel(ContactOrderBy.LastNameDesc + '', 'Last name', 'Z to A', 'desc'),
                new ListItemModel(ContactOrderBy.Company + '', 'Company', 'A to Z', 'asc'),
                new ListItemModel(ContactOrderBy.CompanyDesc + '', 'Company', 'Z to A', 'desc'),
                new ListItemModel(ContactOrderBy.CreatedDateDesc + '', 'Date created', 'New to Old', 'desc'),
                new ListItemModel(ContactOrderBy.CreatedDate + '', 'Date created', 'Old to New', 'asc'),
                new ListItemModel(ContactOrderBy.ModifiedDateDesc + '', 'Date modified', 'New to Old', 'desc'),
                new ListItemModel(ContactOrderBy.ModifiedDate + '', 'Date modified', 'Old to New', 'asc'),
            ];
        }
        this.currentSortColumn = this.inParams.orderByIn; //+(this.inParams.orderByDesc?1:0)+''; //add 1 if params desc/asc

        this.initSearch();
    }

    subscriptions: Subscription[] = [];
    ngOnDestroy()
    {
        console.log('Contact list component destroyed');
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    private initSearch(): void
    {
        this.resetContacts = true;

        this.inParams.pageNumber = 1;

        this.showSpinner = true;
        this.searchLoading = true;

        this.loadData();
    }

    loadData(event = null)
    {
        return this.getContacts(this.inParams)
            .pipe(timeout(Constants.ApiDefaultTimeout))
            .subscribe({
                next: (x) =>
                {
                    this.handleResults(x.contacts);

                    this.showSpinner = false;
                    this.isLoadingNewSearch = false;
                    this.searchLoading = false;
                    this.searchReloading = false;
                    this.rowCnt = x.resultCount;

                    if (x.resultCount > 0 || this.inParams.pageNumber == 1)
                    {
                        this.rowCntFormatted = this.numberWithCommas(x.resultCount);
                    }
                },
                error: (err) =>
                {
                    this.showSpinner = false;
                    this.isLoadingNewSearch = false;
                    this.searchLoading = false;
                    this.searchReloading = false;
                    console.error(err);
                    this.userService.handleError(err);
                }
            });

    }

    private getContacts(prms: ContactSearchParamsModel): Observable<ContactSearchResultModel>
    {
        return this.contactService.getContacts(prms);
    }

    private resultWatcher: Observable<ContactSearchResultModel>;

    async loadSpinner()
    {
        const loading = await this.loadingController.create({
            mode: "ios",
            message: 'Loading...',
            translucent: true,
            cssClass: 'custom-class custom-loading',
            duration: 60000
        });
        return await loading.present();
    }

    private handleResults(contacts: ContactResultModel[]): void
    {
        if (this.resetContacts)
        {
            this.contacts = [];
            this.resetContacts = false;
        }
        this.contacts.push.apply(this.contacts, contacts);
    }

    public hasMore(): boolean
    {
        return this.contacts && this.contacts.length < this.rowCnt;
    }

    public loadMore(): void
    {
        this.searchLoading = true;
        this.inParams.pageNumber++;
        this.loadData();
    }

    showScrollTop: boolean = false;
    scrollTop(): void
    {
        (function smoothScroll()
        {
            var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
            if (currentScroll > 0)
            {
                window.requestAnimationFrame(smoothScroll);
                window.scrollTo(0, currentScroll - (currentScroll / 5));
            }
        })();
    }

    @HostListener('window:scroll', [])
    onWindowScroll()
    {

        if (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop > 100)
        {
            this.showScrollTop = true;
        }
        else if (this.showScrollTop && window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop < 100)
        {
            this.showScrollTop = false;
        }
    }

    sortChanged(ev: any)
    {
        this.isLoadingNewSearch = true;
        this.searchReloading = true;

        if (!this.inParams.enforce)
        {
            this.storage.set(Constants.IonicStorage_ContactListSort, ev);
        }
        this.inParams.orderByIn = ev.replace("Desc", "");
        if (ev.includes("Desc"))
        {
            this.inParams.orderByDesc = true;
        }
        else
        {
            this.inParams.orderByDesc = false;
        }
        this.initSearch();
    }


    private selectedContact: ContactResultModel;

    public itemIsSelected(contact: ContactResultModel): boolean
    {
        if (!this.selectedContact) return false;
        return (contact.id == this.selectedContact.id);
    }

    public selectItem(contact: ContactResultModel)
    {
        this.selectedContact = contact;
        this.contactSelected.emit(contact);
    }

    public canAdd(): boolean
    {
        return (this.userService.hasUserRight(SecurityRight.ContactFunctionsCreate) && (this.inParams.contactType == "Customer" || this.inParams.contactType == "Supplier"));
    }

    public promptForNewContact(): boolean
    {
        if (this.contacts && !this.searchLoading && !this.searchReloading && (/\s/.test(this.inParams.searchText) || (this.inParams.searchText && this.inParams.searchText.length > 0)) && (this.canAdd()) && this.addNew)
        {
            return true;
        }
    }

    async createNewContact(name: string)
    {
        this.newContactSelected.emit(name);
    }

    public numberWithCommas(x: any): string
    {
        return StringHelper.numberWithCommas(x);
    }
}
